import { CardContent, TextField } from "@material-ui/core";
import Card from "@material-ui/core/Card";
import CardTitle from "@saleor/components/CardTitle";
import ControlledCheckbox from "@saleor/components/ControlledCheckbox";
import FormSpacer from "@saleor/components/FormSpacer";
import MultimediaEditor from "@saleor/components/MultimediaEditor";
import SingleSelectField from "@saleor/components/SingleSelectField";
import { PageErrorFragment } from "@saleor/fragments/types/PageErrorFragment";
import { commonMessages } from "@saleor/intl";
import { PageHeaderLocatedEnum } from "@saleor/types/globalTypes";
import { getFormErrors } from "@saleor/utils/errors";
import getPageErrorMessage from "@saleor/utils/errors/page";
import React, { useState } from "react";
import { useIntl } from "react-intl";

import { PageheaderPageFormData } from "../PageheaderPage/PageheaderPage";
export interface PageheaderDetailsProps {
  data: PageheaderPageFormData;
  disabled: boolean;
  errors: PageErrorFragment[];
  onChange: (event: any) => void;
  title: string;
}
const PageheaderDetails: React.FC<PageheaderDetailsProps> = ({
  data,
  disabled,
  errors,
  onChange
}) => {
  const intl = useIntl();

  const PageHeaderLocatedChoices = [
    {
      label: intl.formatMessage({
        defaultMessage: "Top",
        description: "pageheader located choices"
      }),
      value: PageHeaderLocatedEnum.TOP
    },
    {
      label: intl.formatMessage({
        defaultMessage: "Bottom",
        description: "pageheader located choices"
      }),
      value: PageHeaderLocatedEnum.BOTTOM
    },
    {
      label: intl.formatMessage({
        defaultMessage: "Float",
        description: "pageheader located choices"
      }),
      value: PageHeaderLocatedEnum.FLOAT
    },
    {
      label: intl.formatMessage({
        defaultMessage: "Checkout",
        description: "pageheader located choices"
      }),
      value: PageHeaderLocatedEnum.CHECKOUT
    }
  ];
  const [pcdirty, setPcdirty] = useState(false);
  const [mbdirty, setMbdirty] = useState(false);
  const formErrors = getFormErrors(
    ["name", "isDefault", "pcContent", "mobileContent", "located", "isTop"],
    errors
  );
  // const exampleValue = "{10}";
  return (
    <Card>
      <CardTitle
        title={intl.formatMessage(commonMessages.generalInformations)}
      />
      <CardContent>
        <TextField
          disabled={disabled}
          label={intl.formatMessage({
            defaultMessage: "Name Of Pageheader",
            description: "the Name text of the pageheader"
          })}
          error={!!formErrors.name}
          name={"name" as keyof PageheaderPageFormData}
          fullWidth
          helperText={getPageErrorMessage(formErrors.name, intl)}
          value={data.name}
          onChange={onChange}
        />
        <FormSpacer />
        {/* <TextField
          disabled={disabled}
          error={!!formErrors.pcContent}
          label={intl.formatMessage({
            defaultMessage: "PC Content",
            description: "the pc content for pageheader text"
          })}
          name={"pcContent" as keyof PageheaderPageFormData}
          fullWidth
          helperText={
            getPageErrorMessage(formErrors.pcContent, intl) ||
            intl.formatMessage({
              defaultMessage:
                `If currency is included, please use the specified format, e.g. US\${exampleValue}`,
              description: "pageheader pc text input field helper text"
            },
            { exampleValue })
          }
          value={data.pcContent}
          onChange={onChange}
        /> */}
        <MultimediaEditor
          initialValue={data.pcContent}
          setDirty={setPcdirty}
          dirty={pcdirty}
          editorName={"PC Content"}
          editorHeight={150}
          update={newtemplate => {
            const data = {
              target: {
                name: "pcContent",
                value: newtemplate
              }
            };
            onChange(data);
          }}
        />
        <FormSpacer />
        {/* <TextField
          disabled={disabled}
          label={intl.formatMessage({
            defaultMessage: "Mobile Content",
            description: "the mobile content for pageheader text"
          })}
          error={!!formErrors.mobileContent}
          name={"mobileContent" as keyof PageheaderPageFormData}
          fullWidth
          helperText={
            getPageErrorMessage(formErrors.mobileContent, intl) ||
            intl.formatMessage({
              defaultMessage:
                `If currency is included, please use the specified format, e.g. US\${exampleValue}`,
              description: "pageheader mobile text input field helper text"
            },
            { exampleValue })
          }
          value={data.mobileContent}
          onChange={onChange}
        /> */}
        <MultimediaEditor
          initialValue={data.mobileContent}
          setDirty={setMbdirty}
          dirty={mbdirty}
          editorName={"MB Content"}
          editorHeight={150}
          update={newtemplate => {
            const data = {
              target: {
                name: "mobileContent",
                value: newtemplate
              }
            };
            onChange(data);
          }}
        />
        <FormSpacer />
        <SingleSelectField
          disabled={disabled}
          choices={PageHeaderLocatedChoices}
          error={!!formErrors.located}
          hint={getPageErrorMessage(formErrors.located, intl)}
          label={intl.formatMessage({
            defaultMessage: "Located Position",
            description: "Pageheader's Located Position"
          })}
          name="located"
          onChange={onChange}
          value={data.located}
        />
        <FormSpacer />
        <ControlledCheckbox
          name={"isDefault" as keyof PageheaderPageFormData}
          label={intl.formatMessage({
            defaultMessage: "Use in Default Page",
            description: "check to require active to have value"
          })}
          checked={data.isDefault}
          onChange={onChange}
          disabled={disabled}
        />

        {data.located !== PageHeaderLocatedEnum.CHECKOUT && (
          <>
            <ControlledCheckbox
              name={"countdown" as keyof FormData}
              label={intl.formatMessage({
                defaultMessage: "Use for old TimePicker",
                description: "check to require active to have value"
              })}
              checked={data.countdown}
              onChange={onChange}
              disabled={disabled}
            />
            <ControlledCheckbox
              name={"isTop" as keyof PageheaderPageFormData}
              label={intl.formatMessage({
                defaultMessage: "InfoBar isTop",
                description: "check to require active to have value"
              })}
              checked={data.isTop}
              onChange={onChange}
              disabled={disabled}
            />
          </>
        )}
      </CardContent>
    </Card>
  );
};
export default PageheaderDetails;
